import { HttpParams } from '@angular/common/http';

export class AppHttpParams extends HttpParams {
  constructor(
    public options: {
      params?: { [param: string]: string | string[]; };
      responseLabel?: string;
      notifySuccess?: boolean;
      notifyError?: boolean;
    }
  ) {
    const newParams: { [key: string]: string | string[] } = { ...options.params };
    if (options.responseLabel) {
      newParams['responseLabel'] = options.responseLabel;
    }
    if (options.notifySuccess !== undefined) {
      newParams['notifySuccess'] = options.notifySuccess.toString();
    }
    if (options.notifyError !== undefined) {
      newParams['notifyError'] = options.notifyError.toString();
    }
    super({ fromObject: newParams });
  }
}
